module.exports = "<ng-progress [spinner]=\"false\" [thick]=\"true\" color=\"#9e1915\"></ng-progress>\n<router-outlet></router-outlet>"